import React from "react";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Get In Touch"
        title={["WE'RE ALWAYS", "HAPPY TO HEAR", "FROM YOU."]}
        subtitle="Whether you have a question, a suggestion, or just want to say hello — we're here to help."
      />
      <Contact />
    </>
  );
}
